/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalFilterStateResponse
 */
export interface GlobalFilterStateResponse {
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterStateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterStateResponse
     */
    errorMessage?: string | null;
}

export function GlobalFilterStateResponseFromJSON(json: any): GlobalFilterStateResponse {
    return GlobalFilterStateResponseFromJSONTyped(json, false);
}

export function GlobalFilterStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function GlobalFilterStateResponseToJSON(value?: GlobalFilterStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


